import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams, useNavigate } from 'react-router-dom'

import ComboBox from '../../../../../../Components/ComboBox'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../../../utils/api'
import { currentDate } from '../../../../../../utils/helpers'
import urls from '../../../../../../utils/urls'

export default function CreateOperationForm({ setOperations }) {
  const { id } = useParams()
  const [open, setOpen] = useState(false)
  const [accountNom, setAccountNom] = useState([])
  const [vehicule, setVehicule] = useState({})

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      SousCategorie: '',
      NumeroCompte: '',
      Date: currentDate(),
      Montant: '',
      Libelle: '',
    },
  })

  useEffect(() => {
    fetchAccountNom()
    fetchVehicleDetail()
    // fetchBoatTypes();
  }, [])
  const fetchVehicleDetail = async () => {
    const response = await makeGetRequest(urls.crudVehiclesOperations + id, {}, true)
    if (response.status === 200) {
      setVehicule(response.data)
    }
  }
  const fetchAccountNom = async () => {
    const url = urls.fetchAllAccounts + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Nom?.Nom || v.IBAN}`, id: v.id })
      })
      setAccountNom([...filterTypes])
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    payload.SousCategorie = vehicule.category

    const response = await makePostRequest(urls.crudVehiclesFsiOperations, payload, {}, true)
    if (response.status === 201) {
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>créer</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ bgcolor: 'black' }}>Ajout OperationsFis </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('NumeroCompte', j.id)}
              label="Compte"
              data={accountNom}
              name="NumeroCompte"
              required={true}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Date"
              label="Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Libelle"
              label="Libellé"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Montant"
              label="Montant"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
